import * as types from '../mutation-types'
import req from '../../lib/authRequest'
import dates from '../../lib/dates'
/*
  Module for interacting with the data relating to a customer's services
*/

// Initial state
const state = {
  'Business Connectivity': 2,
  'Residential Connectivity': 17,
  'Colocation': 19,
  'Domains': 23,
  'Email': 21,
  'Hosting': 20,
  'Miscellaneous': 22,
  'Professional Services': 18,
  'SSL Certificates': 24,
  'Voice Services': 1,
  allServices: [],
  allProducts: [],
  colocations: [],
  emails: [],
  hosting: [],
  emailAliases: [],
  pleskServers: [],
  connectivity: [],
  domains: [],
  ssl: [],
  voip: [],
  tasks: [],
  servicePanelsOpen: {
    summary: false,
    colocations: false,
    domains: false,
    emails: false,
    hosting: false,
    connectivity: false,
    dnspanel: false,
    servers: false,
    ssl: false,
    voip: false
  }
}

const getters = {
  servicesCount: state => {
    return state.allProducts.length
  },
  dateFormat: (state) => (str) => {
    return dates.dateFormat(str)
  },
  colocationsCount: state => state.colocations.length,
  domainsCount: state => state.domains.length,
  emailsCount: state => state.emails.length,
  hostingCount: state => state.hosting.length,
  connectivityCount: state => state.connectivity.length,
  sslCount: state => state.ssl.length,
  voipCount: state => state.voip.length,
  hasColocations: (state, getters) => getters.colocationsCount > 0,
  hasEmails: (state, getters) => getters.emailsCount > 0,
  hasDomains: (state, getters) => getters.domainsCount > 0,
  hasHosting: (state, getters) => getters.hostingCount > 0,
  hasConnectivity: (state, getters) => getters.connectivityCount > 0,
  hasSSL: (state, getters) => getters.sslCount > 0,
  hasVoip: (state, getters) => getters.voipCount > 0,
  allPanelsOpen: state => {
    for (var i in state.servicePanelsOpen) {
      if (state.servicePanelsOpen[i]) {
        return false
      }
    }
    return true
  }
}

const mutations = {
  [types.ADD_CONNECTIVITY] (state, {reset, result}) {
    if (reset) {
      state.connectivity = []
    }

    if (result[state['Business Connectivity']] !== undefined) {
      for (var i = 0; i < result[state['Business Connectivity']].length; i++) {
        state.connectivity = state.connectivity.concat(result[state['Business Connectivity']][i].products)
      }
    }
    if (result[state['Residential Connectivity']] !== undefined) {
      for (i = 0; i < result[state['Residential Connectivity']].length; i++) {
        state.connectivity = state.connectivity.concat(result[state['Residential Connectivity']][i].products)
      }
    }
  },
  [types.ADD_COLOCATIONS] (state, {reset, colocations}) {
    if (reset) {
      state.colocations = []
    }
    if (colocations !== undefined) {
      for (var i = 0; i < colocations.length; i++) {
        state.colocations = state.colocations.concat(colocations[i].products)
      }
    }
  },
  [types.ADD_EMAILS] (state, {reset, emails}) {
    if (reset) {
      state.emails = []
    }
    if (emails !== undefined) {
      state.emails = emails
    }
  },
  [types.ADD_HOSTING] (state, {reset, hosting}) {
    if (reset) {
      state.hosting = []
    }

    if (hosting !== undefined) {
      state.hosting = hosting
    }
  },
  [types.ADD_DOMAINS] (state, {reset, domains}) {
    if (reset) {
      state.domains = []
    }

    if (domains !== undefined) {
      state.domains = domains
    }
  },
  [types.SET_PLESK_SERVERS] (state, pleskServers) {
    state.pleskServers = pleskServers
  },
  [types.SET_SSL] (state, ssl) {
    state.ssl = []
    if (ssl !== undefined) {
      for (var i = 0; i < ssl.length; i++) {
        state.ssl = state.ssl.concat(ssl[i].products)
      }
    }
  },
  [types.ADD_VOIP] (state, {reset, voip}) {
    if (reset) {
      state.voip = []
    }
    if (voip !== undefined) {
      for (var i = 0; i < voip.length; i++) {
        state.voip = state.voip.concat(voip[i].products)
      }
    }
  },
  [types.OPEN_ALL_SERVICE_PANELS] (state) {
    for (var panel in state.servicePanelsOpen) {
      state.servicePanelsOpen[panel] = true
    }
  },
  [types.CLOSE_ALL_BUT_ONE_SERVICE_PANEL] (state, service) {
    for (var panel in state.servicePanelsOpen) {
      if (panel === service) {
        state.servicePanelsOpen[panel] = true
      } else {
        state.servicePanelsOpen[panel] = false
      }
    }
  },
  [types.CLOSE_ALL_SERVICE_PANELS] (state) {
    for (var panel in state.servicePanelsOpen) {
      state.servicePanelsOpen[panel] = false
    }
  },
  [types.TOGGLE_SERVICE_PANEL] (state, service) {
    state.servicePanelsOpen[service] = !state.servicePanelsOpen[service]
  },
  [types.OPEN_SERVICE_PANEL] (state, service) {
    state.servicePanelsOpen[service] = true
  },
  [types.CLOSE_SERVICE_PANEL] (state, service) {
    state.servicePanelsOpen[service] = false
  },
  [types.SET_PROVISION_TASKS] (state, tasks) {
    state.tasks = []
    for (let task of tasks){
      if (['complete', 'error'].includes(task.status)) {
        continue;
      }
      state.tasks.push(task);
      if (task.service_class_id === 14) {
        task.status = task.status.toUpperCase();
        task.created_date = task.creation_dt;
        task.activated_date = null;
        let duplicate = false;
        for (let connection of state.connectivity) {
          if (connection.number2 === task.service_display_id) {
            duplicate = true;
            break;
          }
        }
        if (!duplicate) {
          state.connectivity.push(task);
        }
      }
    }
  },
}

const actions = {
  /**
   * Gets all of the services from the server
   */
  getAllServices ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      // Get the services that have their own module
      dispatch('getZones')
      dispatch('getServers')
      dispatch('getPleskServers')

      req.get({
        url: '/services',
        success (result) {
          var reset = true

          commit(types.ADD_DOMAINS, {'reset': reset, 'domains': result.services[state['Domains']]})
          commit(types.ADD_CONNECTIVITY, {'reset': reset, 'result': result.services})
          commit(types.ADD_HOSTING, {'reset': reset, 'hosting': result.services[state['Hosting']]})
          commit(types.ADD_COLOCATIONS, {'reset': reset, 'colocations': result.services[state.Colocation]})
          commit(types.ADD_EMAILS, {'reset': reset, 'emails': result.services[state.Email]})
          commit(types.ADD_VOIP, {'reset': reset, 'voip': result.services[state['Voice Services']]})

          if (result['has_more'] === true) {
            commit(types.ADD_NOTIFICATION, {'type': 'danger', 'message': 'Not all products were fetched'})
          }
          dispatch('getProvisionTasks')
          resolve()
        }
      })
    })
  },
  getPleskServers ({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      req.get({
        url: '/plesk_servers',
        success (result) {
          commit(types.SET_PLESK_SERVERS, result)
          resolve(result)
        },
        error (result) {
          reject(result)
        }
      })
    })
  },
   getProvisionTasks({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      req.get({
        url: '/services/provisioning/tasks',
        success (result) {
          commit(types.SET_PROVISION_TASKS, result)
          resolve(result)
        },
        error (result) {
          reject(result)
        }
      })
    })
  },
}

export default {
  actions,
  getters,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/services.js